<template>
  <div class="api-module api-mlp-tracking">
    <!--
    <p class = "description">
      This is a recording of what the camera might see.
    </p>
    -->

    <div class = "video-wrapper">
      <canvas ref = "canvas"></canvas>

      <video ref = "video" poster="/static/tracking/camera/camera.png">
        <source src ="/static/tracking/camera/output.mov" type="video/mov">
        <source src ="/static/tracking/camera/output.webm" type="video/webm">
        <source src ="/static/tracking/camera/output.ogv" type="video/ogg">
        <source src ="/static/tracking_medialabprado/output.mp4" type="video/mp4">
      </video>
    </div>
    <div id="video-ctr-block">
      <button v-if = "!isPlaying" class = "btn btn-light btn-icon" v-on:click = "play(true)"><span class = "material-icons md-24">play_arrow</span></button>
      <button v-else class = "btn btn-light btn-icon" v-on:click = "play(stop)"><span class = "material-icons md-24">stop</span></button>
      <button class = "btn btn-light btn-icon" v-on:click = "setRepeat"><span class = "material-icons md-24">replay</span></button>
    </div>
 </div>
</template>

<script>
import tuioVideo from './tuio-video.json'

export default {
  name: 'ApiMlpTracking',
  components: {
  },
  props: {
  },
  watch: {
    'editorConfig.videoPlayerShouldStartPlaying': function (videoPlayerShouldStartPlaying) {
      // console.log('cuak', videoPlayerShouldStartPlaying, this.editorConfig.videoPlayerShouldStartPlaying)
      if (this.editorConfig.isSketchRunning && videoPlayerShouldStartPlaying) {
        // console.log('tracking (isSketchRunning)', videoPlayerShouldStartPlaying)
        this.play(videoPlayerShouldStartPlaying)
      }
    },
    'editorConfig.isSketchRunning': function (isSketchRunning) {
      // console.log('cuak2', isSketchRunning)
      if (this.editorConfig.videoPlayerShouldStartPlaying) {
        this.play(isSketchRunning)
        this.clearVideoTracking()
        if (!isSketchRunning) { }
      }
    }
  },
  data () {
    return {
      isPlaying: false,
      isRepeatingVideo: false
    }
  },
  computed: {
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  methods: {
    play: function (status) {
      if (status) {
        // console.log('play')
        this.videoPlayer.pause()
        this.videoPlayer.currentTime = 0
        this.videoPlayer.play()
        this.isPlaying = true
      } else {
        // console.log('stop')
        this.videoPlayer.pause()
        this.videoPlayer.currentTime = 0
        this.isPlaying = false
      }
    },
    clearVideoTracking: function () {
      this.c.clearRect(0, 0, this.canvas.width, this.canvas.height)
    },
    prepare: function () {
      this.videoPlayer = this.$refs.video
      this.canvas = this.$refs.canvas
      this.c = this.canvas.getContext('2d')
      this.videoPlayer.addEventListener('timeupdate', (time) => {
        // console.log(this.videoPlayer.currentTime)

        for (let i in tuioVideo) {
          if (tuioVideo[i][0].time > this.videoPlayer.currentTime * 1000) {
            // console.log('got it ' + tuioVideo[i][0].time + ' ' + time.timeStamp)

            // the first element of the array is the time
            if (tuioVideo[i].length > 1) {
              // console.log('qq 1', tuioVideo[i])

              let blobs = []
              this.c.clearRect(0, 0, this.canvas.width, this.canvas.height)
              for (let j = 1; j < tuioVideo[i].length; j++) {
                // console.log('qq2')

                let xScreen = Math.round(tuioVideo[i][j].x * 192 / 320)
                let yScreen = Math.round(tuioVideo[i][j].y * 192 / 320)

                let xVideo = Math.round(tuioVideo[i][j].x * 320 / 352) // * 192 / 320
                let yVideo = Math.round(tuioVideo[i][j].y * 240 / 350) // * 157 / 240

                // this.c.fillStyle = 'rgba(255, 255, 255, 0)'
                // this.c.fillRect(0, 0, this.canvas.width, this.canvas.height)
                this.c.font = 'bold 8pt Courier'
                this.c.strokeStyle = 'hsl(' + (j - 1) * 100 + ', 50%, 50%)'
                this.c.fillStyle = 'hsl(' + (j - 1) * 100 + ', 50%, 50%)'
                this.c.lineWidth = 3
                this.c.shadowColor = 'rgba(0, 0, 0, 0.2)'
                this.c.shadowBlur = 1
                this.c.shadowOffsetX = 1
                this.c.shadowOffsetY = 1

                this.c.strokeRect(xVideo - 5, yVideo, 15, -25)
                this.c.fillText(xScreen + ', ' + yScreen, xVideo - 15, yVideo + 12)

                blobs.push({ 'id': j, 'x': xScreen, 'y': yScreen })
              }
              this.sendBlobToPreviewer(blobs)
            }

            break
          }
        }
      })

      this.videoPlayer.addEventListener('ended', () => {
        console.log('video finished')
      }, false)

      // console.log('tuioVideo:', tuioVideo)
    },
    setRepeat: function () {
      // console.log('repeat')
      this.play(true)
      // this.isRepeatingVideo = !this.isRepeatingVideo
    },
    sendBlobToPreviewer: function (blob) {
      this.$eventHub.$emit('rtdata', { from: 'onNewBlobs', value: blob })
    }
  },
  mounted () {
    this.prepare()
    // console.log('ApiMlpTracking mounted', this.editorConfig.videoPlayerShouldStartPlaying)
    if (this.editorConfig.videoPlayerShouldStartPlaying) {
      this.play(true)
      this.$store.commit('setEditorConfigProperty', {'videoPlayerShouldStartPlaying': false})
    }
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.api-mlp-tracking {
}

.video-wrapper {
  position: relative;
  align-self: center;
  width: 320px;
  height: 240px;

  canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    // border: 1px solid white;
  }
}

#video-ctr-block {
  display: flex;
  align-self: center;

  button {
    padding: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ApiModules/ApiMlpTracking.vue